// Hub de Campo (2026-06-19): junta numa página só, em abas, os módulos
// operacionais de campo — Diário, Dados, Planejamento e Kits. Cada aba gateia
// pela sua perm própria; carrega só a aba ativa (destroyInactiveTabPane) pra os
// mapas/tabelas não montarem todos de uma vez. As páginas individuais continuam
// acessíveis por URL direta (deep-links / notificações) — só saíram da sidebar.
import { useMemo, useState } from 'react';
import { Tabs, Empty } from 'antd';
import { usePerms } from '../hooks/usePerms';
import OperacionalDiarioCampo from './OperacionalDiarioCampo';
import OperacionalDadosCampo from './OperacionalDadosCampo';
import PlanejamentoCampo from './PlanejamentoCampo';
import KitsCampo from './KitsCampo';
import OperacionalMarcos from './OperacionalMarcos';

const TABS = [
  { key: 'diario',       label: '📝 Diário de Campo',       perm: 'operacional.diario_campo.listar',     Comp: OperacionalDiarioCampo },
  { key: 'dados',        label: '📬 Dados de Campo',        perm: 'operacional.dados_campo.listar',      Comp: OperacionalDadosCampo },
  { key: 'planejamento', label: '📅 Planejamento de Campo', perm: 'operacional.planejamento_campo.ver',  Comp: PlanejamentoCampo },
  { key: 'kits',         label: '📦 Kits de Equipamento',   perm: 'operacional.kits.ver',                Comp: KitsCampo },
  { key: 'marcos',       label: '📍 Marcos Geodésicos',     perm: 'operacional.marcos.ver',              Comp: OperacionalMarcos },
];

export default function OperacionalCampoHub() {
  const { pode } = usePerms();
  const ehAdmin = pode('admin.permissoes.editar');
  const visiveis = useMemo(() => TABS.filter((t) => ehAdmin || pode(t.perm)), [ehAdmin, pode]);
  const [ativa, setAtiva] = useState<string | undefined>(visiveis[0]?.key);

  if (!visiveis.length) {
    return <div style={{ padding: 24 }}><Empty description="Você não tem acesso a nenhum módulo de campo." /></div>;
  }

  const items = visiveis.map((t) => ({ key: t.key, label: t.label, children: <t.Comp /> }));
  const activeKey = ativa && visiveis.some((t) => t.key === ativa) ? ativa : visiveis[0].key;

  return (
    <Tabs
      activeKey={activeKey}
      onChange={setAtiva}
      items={items}
      destroyInactiveTabPane
      tabBarStyle={{ paddingLeft: 16, marginBottom: 0 }}
    />
  );
}
